import { render, staticRenderFns } from "./alarmList.vue?vue&type=template&id=5a97029f&scoped=true&"
import script from "./alarmList.vue?vue&type=script&lang=js&"
export * from "./alarmList.vue?vue&type=script&lang=js&"
import style0 from "./alarmList.vue?vue&type=style&index=0&id=5a97029f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a97029f",
  null
  
)

export default component.exports